var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"profile-edit"}},[_c('h4',[_vm._v("Edit Profile")])])
}]

export { render, staticRenderFns }